export default __webpack_public_path__ + "static/media/benefits-3.6401ff80.svg";